// Generated by tools/generateWidgets.js 
export default () => ({
	"Divider.widget.js": require("./Divider.widget.js"),
	"EmbeddedTweet.widget.js": require("./EmbeddedTweet.widget.js"),
	"Fresh8Strapline.widget.js": require("./AdvertStrapline.widget.js"),
  "AdvertStrapline.widget.js": require("./AdvertStrapline.widget.js"),
	"Image.widget.js": require("./Image.widget.js"),
	"OoyalaEmbed.widget.js": require("./OoyalaEmbed.widget.js"),
	"PlaybuzzEmbed.widget.js": require("./PlaybuzzEmbed.widget.js"),
	"Racerunner.widget.js": require("./Racerunner.widget.js"),
	"TextArea.widget.js": require("./TextArea.widget.js"),
	"Tip.widget.js": require("./Tip.widget.js"),
	"YouTubeVideo.widget.js": require("./YouTubeVideo.widget.js"),
});



// WEBPACK FOOTER //
// ./modules/News/components/widgets/importAllWidgets.js